module.exports = __webpack_public_path__ + "static/media/logo-mobile.49e00601.svg";